import "../../css/inner-page/sectionDiscount.scss";
import CTA from "../CTA";
import { ReactComponent as Discount } from "../imgComponents/discount.svg";
import { ReactComponent as Y } from "../imgComponents/y.svg";

export default function Section(props) {
  const ypSellers = (typeof window.Cookies !== "undefined" && window.Cookies.get("_yp_seller")) || false;
  if ((typeof window.isVb !== "undefined" && window.isVb) || ypSellers) {
    return null;
  }

  const _dy_df_geo = (typeof window.Cookies !== "undefined" && window.Cookies.get("_dy_df_geo")) || false;
  let price = 500;
  let currencySign = "$";
  if (_dy_df_geo) {
    const country = _dy_df_geo.split(".")[0];
    if (country === "United Kingdom") {
      price = 400;
      currencySign = "£";
    }
    if (country === "Australia") {
      price = 700;
    }
  }
  return (
    <section id="discount">
      <div className="wrapper">
        <Discount className="discount-sticker" data-aos="fade" />
        <div className="yotpo-y">
          <Y />
        </div>
        {/* <span data-aos="fade">{props.pre_title}</span> */}
        {/* {props.title} */}
        <h2 data-aos="fade">
          Get {currencySign + price.toLocaleString()} or more off Yotpo solutions for Black Friday
        </h2>
        <CTA href={props.cta.url} title={props.cta.title} icon="arrow-right" segmentLocation="Discount banner" />
      </div>
    </section>
  );
}
